import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Ingeniería de Medios',
      text: 'Al igual que Bancaribe, TNO es una plataforma tecnológica. Nuestra infraestructura garantiza latencia mínima, asegurando que el mensaje del banco se transmita con la misma estabilidad que sus operaciones financieras.',
    },
    {
      title: 'Validación de Margarita Toledo',
      text: 'Su credibilidad blinda la reputación de Bancaribe, convirtiendo al banco en una recomendación de una figura respetada, no en una cuña más.',
    },
    {
      title: 'Omnicanalidad Real',
      text: 'No es solo radio; es una estrategia que vive en la Web, la App, las redes sociales y el streaming visual 24/7.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Diferencial
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          El Diferencial TNO Network
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;
